import { exists } from '../runtime.js';
import './ApiActivityType.js';
import './ApiAdditionalInfoType.js';
import './ApiAirportType.js';
import './ApiBaggageType.js';
import './ApiBaggageUnitType.js';
import { ApiBaseDataFromJSON, ApiBaseDataToJSON } from './ApiBaseData.js';
import { ApiBaseDataImageFromJSON, ApiBaseDataImageToJSON } from './ApiBaseDataImage.js';
import './ApiBaseDataSource.js';
import './ApiBookingAction.js';
import './ApiBookingState.js';
import './ApiCabinClass.js';
import './ApiCamperFeatureType.js';
import './ApiClientType.js';
import './ApiComponentPriceType.js';
import './ApiComponentType.js';
import './ApiConfigurationDataType.js';
import './ApiDebitType.js';
import './ApiDirection.js';
import './ApiDistanceUnit.js';
import './ApiDocumentSubType.js';
import './ApiDocumentType.js';
import { ApiDurationInfoFromJSON, ApiDurationInfoToJSON } from './ApiDurationInfo.js';
import './ApiDurationType.js';
import './ApiFilterCategory.js';
import './ApiFilterType.js';
import './ApiFuelType.js';
import './ApiGender.js';
import { ApiGeoAssignmentFromJSON, ApiGeoAssignmentToJSON } from './ApiGeoAssignment.js';
import { ApiHotelRoomFromJSON, ApiHotelRoomToJSON } from './ApiHotelRoom.js';
import { ApiImageContainerFromJSON, ApiImageContainerToJSON } from './ApiImageContainer.js';
import './ApiImageType.js';
import { ApiImportantInfoFromJSON, ApiImportantInfoToJSON } from './ApiImportantInfo.js';
import { ApiIncludedServiceFromJSON, ApiIncludedServiceToJSON } from './ApiIncludedService.js';
import './ApiInventory.js';
import './ApiItemType.js';
import { ApiNoteFromJSON, ApiNoteToJSON } from './ApiNote.js';
import './ApiNoteOriginType.js';
import './ApiNoteType.js';
import './ApiPackagePriceComponentType.js';
import './ApiPaymentDataType.js';
import './ApiPaymentOption.js';
import './ApiPaymentState.js';
import './ApiPriceModifierType.js';
import './ApiPriceType.js';
import './ApiRecommendationServiceType.js';
import './ApiRelatedServiceRelationType.js';
import './ApiRole.js';
import { ApiRoomThemeFromJSON, ApiRoomThemeToJSON } from './ApiRoomTheme.js';
import './ApiRowCharacteristics.js';
import './ApiSeatCharacteristics.js';
import { ApiServiceFromJSONTyped, ApiServiceToJSON } from './ApiService.js';
import './ApiServiceSelectionType.js';
import { ApiServiceSupplierAddressFromJSON, ApiServiceSupplierAddressToJSON } from './ApiServiceSupplierAddress.js';
import './ApiSortDirection.js';
import './ApiSortOption.js';
import { ApiSpecialOfferFromJSON, ApiSpecialOfferToJSON } from './ApiSpecialOffer.js';
import './ApiSpecialRequestGroup.js';
import './ApiStaticContentType.js';
import './ApiTaxDisplay.js';
import './ApiTransmissionType.js';
import './ApiTravelStatusEnum.js';
import './ApiTravelerType.js';
import './ApiVoucherDeliveryType.js';
import './ApiWalletType.js';

/* tslint:disable */
function ApiHotelFromJSON(json) {
    return ApiHotelFromJSONTyped(json, false);
}
function ApiHotelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...ApiServiceFromJSONTyped(json, ignoreDiscriminator),
        'hotelLogo': !exists(json, 'hotelLogo') ? undefined : ApiImageContainerFromJSON(json['hotelLogo']),
        'shortDescription': json['shortDescription'],
        'category': ApiBaseDataFromJSON(json['category']),
        'serviceType': ApiBaseDataFromJSON(json['serviceType']),
        'rating': json['rating'],
        'durationInfo': ApiDurationInfoFromJSON(json['durationInfo']),
        'geoAssignment': ApiGeoAssignmentFromJSON(json['geoAssignment']),
        'rooms': (json['rooms'].map(ApiHotelRoomFromJSON)),
        'characteristics': (json['characteristics'].map(ApiBaseDataFromJSON)),
        'supplierAddress': !exists(json, 'supplierAddress') ? undefined : ApiServiceSupplierAddressFromJSON(json['supplierAddress']),
        'highlights': !exists(json, 'highlights') ? undefined : json['highlights'],
        'localAttractions': !exists(json, 'localAttractions') ? undefined : json['localAttractions'],
        'serviceOptions': (json['serviceOptions'].map(ApiBaseDataFromJSON)),
        'serviceGroups': !exists(json, 'serviceGroups') ? undefined : (json['serviceGroups'].map(ApiBaseDataFromJSON)),
        'notes': (json['notes'].map(ApiNoteFromJSON)),
        'includedServices': !exists(json, 'includedServices') ? undefined : (json['includedServices'].map(ApiIncludedServiceFromJSON)),
        'additionalInfo': !exists(json, 'additionalInfo') ? undefined : (json['additionalInfo'].map(ApiImportantInfoFromJSON)),
        'themes': !exists(json, 'themes') ? undefined : (json['themes'].map(ApiRoomThemeFromJSON)),
        'specialAmenities': !exists(json, 'specialAmenities') ? undefined : (json['specialAmenities'].map(ApiBaseDataImageFromJSON)),
        'availability': !exists(json, 'availability') ? undefined : json['availability'],
        'specialOffer': !exists(json, 'specialOffer') ? undefined : ApiSpecialOfferFromJSON(json['specialOffer']),
    };
}
function ApiHotelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ApiServiceToJSON(value),
        'hotelLogo': ApiImageContainerToJSON(value.hotelLogo),
        'shortDescription': value.shortDescription,
        'category': ApiBaseDataToJSON(value.category),
        'serviceType': ApiBaseDataToJSON(value.serviceType),
        'rating': value.rating,
        'durationInfo': ApiDurationInfoToJSON(value.durationInfo),
        'geoAssignment': ApiGeoAssignmentToJSON(value.geoAssignment),
        'rooms': (value.rooms.map(ApiHotelRoomToJSON)),
        'characteristics': (value.characteristics.map(ApiBaseDataToJSON)),
        'supplierAddress': ApiServiceSupplierAddressToJSON(value.supplierAddress),
        'highlights': value.highlights,
        'localAttractions': value.localAttractions,
        'serviceOptions': (value.serviceOptions.map(ApiBaseDataToJSON)),
        'serviceGroups': value.serviceGroups === undefined ? undefined : (value.serviceGroups.map(ApiBaseDataToJSON)),
        'notes': (value.notes.map(ApiNoteToJSON)),
        'includedServices': value.includedServices === undefined ? undefined : (value.includedServices.map(ApiIncludedServiceToJSON)),
        'additionalInfo': value.additionalInfo === undefined ? undefined : (value.additionalInfo.map(ApiImportantInfoToJSON)),
        'themes': value.themes === undefined ? undefined : (value.themes.map(ApiRoomThemeToJSON)),
        'specialAmenities': value.specialAmenities === undefined ? undefined : (value.specialAmenities.map(ApiBaseDataImageToJSON)),
        'availability': value.availability,
        'specialOffer': ApiSpecialOfferToJSON(value.specialOffer),
    };
}

export { ApiHotelFromJSON, ApiHotelFromJSONTyped, ApiHotelToJSON };
//# sourceMappingURL=ApiHotel.js.map
